import http from '@/utils/http';
const base_path = '/v2/tool/nativeAnchor';

/**
 * 获取原生锚点列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getNativeAnchorApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步原生锚点接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullNativeAnchorApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 批量创建原生锚点接口
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const batchCreateNativeAnchorApi = (data) => {
  return http.post({
    url: `${base_path}/batchCreate`,
    data,
  });
};
